'use client';

import { Suspense } from 'react';
import { SessionProvider } from 'next-auth/react';
import { PostHogProductActivityTracking } from '@/components/analytics/PostHogProductActivityTracking';
import { PostHogUserIdentification } from '@/components/analytics/PostHogUserIdentification';
import { PostHogTrafficTracking } from '@/components/analytics/PostHogTrafficTracking';

export default function SessionProviderWrapper({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <PostHogUserIdentification />
      <Suspense fallback={null}>
        <PostHogTrafficTracking />
        <PostHogProductActivityTracking />
      </Suspense>
      {children}
    </SessionProvider>
  );
}
